//* Libraries imports
import { z } from "zod";

//*Schemas imports
import { activitySchema } from "./activity";
import { subprocessGeneratorSchema } from "./subprocess";
import { tutorialSchema } from "./tutorial";
import { FinancialConfigSchema } from "./financial";

export const ProductActivityTypeSchema = z.enum([
  "form",
  "external",
  "document_generation",
]);
export type ProductActivityType = z.infer<typeof ProductActivityTypeSchema>;

export const productActivitySchema = z
  .object({
    _id: z.string().optional(),
    image: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    order: z.number().optional(),
    type: ProductActivityTypeSchema.optional(),
    typeRefId: z.string().optional(),
    hasPreview: z.boolean().optional(),
    duration: z.number().optional(),
    usesBusinessDays: z.boolean().optional(),
    prerequisites: z.array(z.string()).optional(),
    tutorial: z.any().optional(),
    documents: z.any().optional(),
    templates: z.any().optional(),
    techinicals: z.any().optional(),
    createdAt: z.union([z.string(), z.date()]).optional(),
    updatedAt: z.union([z.string(), z.date()]).optional(),
  })
  .catchall(z.any());
export type IProductActivity = z.infer<typeof productActivitySchema>;

export const productPhaseSchema = z.object({
  _id: z.string().optional(),
  name: z.string(),
  type: z.string(),
  image: z.string().optional(),
  description: z.string(),
  order: z.number(),
  activities: z.array(activitySchema),
  subprocessGenerators: z.array(subprocessGeneratorSchema),
  tutorial: tutorialSchema,
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});
export type IProductPhase = z.infer<typeof productPhaseSchema>;

export const productSchema = z.object({
  _id: z.string().optional(),
  name: z.string(),
  number_product: z.string(),
  image: z.string().optional(),
  key: z.string(),
  description: z.string().optional(),
  phases: z.array(productPhaseSchema),
  matters: z.array(z.string()).optional(),
  financialConfig: FinancialConfigSchema,
  tutorial: tutorialSchema,
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});
export type IProduct = z.infer<typeof productSchema>;
